<template>
  <div class="">
    <ym-button class="assist-btn"
               plain
               v-if="showAssist"
               @click="handleAssist"
    >
      点击助力
    </ym-button>
    <template v-else>
      <ym-button class="join-btn"
                 plain
                 v-if="showJoin"
                 @click="handleJoinLottery"
      >
        立即参与抽奖
      </ym-button>
      <ym-button class="join-btn"
                 plain
                 v-else
                 @click="handleShareLottery"
      >
        获得更多抽奖券
      </ym-button>
      <share-mask :show.sync="showShareMask"
                  message="请复制链接，邀请好友参加"
      />
      <center-popup class="get-ticket-rule-popup"
                    :show.sync="showMobile"
                    title="登陆"
      >
        <mobile-login />
      </center-popup>
    </template>
  </div>
</template>

<script>
  import { Button } from 'ym-mint-ui';
  import ClipboardJS from 'clipboard';
  import MobileLogin from '@/pages/2019/TourLottery/PMD/components/MobileLogin';
  import ShareMask from '@/components/ShareMask';
  import { lotteryJoin, lotteryAssist } from '@/services/tour-lottery';
  import {
    isWeiXinBrowser,
    locationHref,
    getStorageRedirect,
    getQuery,
  } from '@/utils';
  import { getLoginWeChatUrl } from '@/services/user';
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'PageLotteryActionBtn',
    components: {
      'ym-button': Button,
      MobileLogin,
      ShareMask,
      CenterPopup,
    },
    props: {
      userFlag: {
        type: String,
        required: true,
      },
      isMember: {
        type: Boolean,
        required: true,
      },
      hasAssist: {
        type: Boolean,
        default: true,
      },
      hasOauth: {
        type: Boolean,
        required: true,
      },
      isLogin: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        weChatLoginUrl: '',
        showMobile: false,
        showShareMask: false,
      };
    },
    computed: {
      showJoin() {
        return !this.isMember;
      },
      showAssist() {
        return !this.hasAssist;
      },
      inWeChat() {
        return isWeiXinBrowser();
      },
      query() {
        return getQuery(this.$route.query);
      },
    },
    methods: {
      async handleJoinLottery() {
        if (this.isLogin) {
          await lotteryJoin();
          this.showMobile = false;
          window.location.reload();
          return;
        }
        if (this.hasOauth) {
          this.showMobile = true;
          return;
        }
        this.handleLoginWithWeChat();
      },
      async fetchWeChatLoginUrl() {
        if (this.inWeChat) {
          // const { redirectTo } = this.query;
          const redirectTo = this.$route.path;
          const path = getStorageRedirect(redirectTo);
          this.weChatLoginUrl = await getLoginWeChatUrl({
            redirectTo: path,
            redirectToAfterWeChatLoginCallBack: path,
          });
        }
      },
      async handleLoginWithWeChat() {
        if (this.weChatLoginUrl === '') {
          await this.fetchWeChatLoginUrl();
        }
        locationHref(this.weChatLoginUrl);
      },
      async handleAssist() {
        if (!this.hasOauth) {
          this.handleLoginWithWeChat();
          return;
        }
        await lotteryAssist(this.userFlag);
      },
      handleShareLottery() {
        if (isWeiXinBrowser()) {
          this.showShareMask = true;
          return;
        }
        const clipboard = new ClipboardJS('.js-share-btn');
        clipboard.on('success', () => {
          this.showShareMask = true;
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/pages/2019/TourLottery/assets/styles/var.less';

  .join-btn,
  .assist-btn {
    width: 598px;
    height: 80px;
    border-radius: 40px;
    background: @color-highlight;
    color: @color-white;
    border: none;
  }

</style>
